import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  giftRegistriesLoad,
  giftRegistryDetailExtendDeadline,
  giftRegistryDetailLoad,
  giftRegistryRefundContributionMarkRefunded,
  giftRegistryRefundItemsLoad,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(giftRegistriesLoad.type, send, socket);
  yield takeEvery(giftRegistryDetailLoad.type, send, socket);
  yield takeEvery(giftRegistryDetailExtendDeadline.type, send, socket);
  yield takeEvery(giftRegistryRefundItemsLoad.type, send, socket);
  yield takeEvery(
    giftRegistryRefundContributionMarkRefunded.type,
    send,
    socket,
  );
}
